/* eslint-disable jsx-a11y/label-has-for */
import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import ApplePay from '../../components/ApplePay';

const PaymentFormApplePay = ({
  onClick,
  formDisabled,
  hasErrors,
  isCoveredByDiscount,
  hasApplePay,
  toggleApplePay,
}) => (
  <form
    className={cx('c-card-information u-flex u-flex-column', { 'c-card-information--discounted': isCoveredByDiscount })}
  >
    <div className="c-payment-modal-heading u-mb">Payment Information</div>
    <div className="u-flex-1 u-flex u-flex-column u-justify-content-space-between">
      {
        !isCoveredByDiscount && (
          <ApplePay onClick={onClick} processing={formDisabled || hasErrors} />
        )
      }
      {
        isCoveredByDiscount && (
          <button className="c-button">
            Process
          </button>
        )
      }
      {
        !isCoveredByDiscount && hasApplePay && (<button
          type="button"
          className="c-btn-link c-btn-link--small u-mt- u-co-black-3 u-font-weight-normal"
          onClick={toggleApplePay}
        >
          Or pay with Card
        </button>)
      }
    </div>
  </form>
);

PaymentFormApplePay.propTypes = {
  formDisabled: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
  hasErrors: PropTypes.bool.isRequired,
  isCoveredByDiscount: PropTypes.bool.isRequired,
  hasApplePay: PropTypes.bool,
  toggleApplePay: PropTypes.func,
};

PaymentFormApplePay.defaultProps = {
  panelLabel: 'Pay',
  hasApplePay: true,
  toggleApplePay: () => {},
};

export default PaymentFormApplePay;



// WEBPACK FOOTER //
// ./src/app/reservation/components/PaymentFormApplePay.jsx